export function color(name, opacity) {
    return opacity
        ? `rgba(var(--ods-color-${name}), ${opacity})`
        : `rgba(var(--ods-color-${name}))`;
}
//# sourceMappingURL=color.js.map